import * as t from "io-ts";
import { UrlIO } from "ui-io/company-io";

export const MegaDealCompanyIO = t.type({
  companyID: t.string,
  name: t.string,
  url: UrlIO,
  totalFunding: t.number,
});

export const MegaDealCompaniesIO = t.array(MegaDealCompanyIO);
export type MegaDealCompanyT = t.TypeOf<typeof MegaDealCompanyIO>;

export const DealByIndustryIO = t.type({
  industry: t.string,
  totalFunding: t.number,
});

export const DealByIndustriesIO = t.array(DealByIndustryIO);
export type DealByIndustryT = t.TypeOf<typeof DealByIndustryIO>;


export const DealByStageIO = t.intersection([
  t.type({
    totalAmount: t.number,
    occurance: t.number,
  }),
  t.partial({ stage: t.union([t.string, t.null]) }),
]);
export const DealByStagesIO = t.array(DealByStageIO);
export type DealByStageT = t.TypeOf<typeof DealByStageIO>;
